
















































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { ManagedExpensesSortableColumns } from "@/shared/types";
import ManagedExpenseColumnSortIcon from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseColumnSortIcon.vue";
import ManagedExpenseColumnHeader from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseColumnHeader.vue";

@Component({
  components: { ManagedExpenseColumnHeader, ManagedExpenseColumnSortIcon },
  computed: {
    ManagedExpensesSortableColumns () {
      return ManagedExpensesSortableColumns;
    }
  }
})
export default class HsabExpenseCardColumns extends Vue {

}
